import { computed } from 'vue'

import type { ComputedRef } from 'vue'

import { useTutorKanbanStore } from './store'

interface MainInfoPremiumReturn {
  refValue: ComputedRef<string>
}

export const useMainInfoPremium = (): MainInfoPremiumReturn => {
  const tutorKanbanStore = useTutorKanbanStore()

  const refValue = computed<string>(() => tutorKanbanStore.getTutor?.is_premium ? 'Yes' : 'No')

  return {
    refValue,
  }
}
